import axios from "axios";
import {API_BASE_URL} from "../constants/api";
import {ACCESS_TOKEN} from "../constants/auth";

const ActCompletionWorkService = {};

ActCompletionWorkService.getACWs = async function (page, limit, categoryId, teacherId) {
    const response = await axios({
        method: "get",
        url: API_BASE_URL + `/api/admin/act-completion-work/get`,
        params: {
            page: page - 1,
            limit: limit,
            categoryId: categoryId === undefined ? null : categoryId,
            teacherId: teacherId === undefined ? null : teacherId
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
    const data = response.data.list;
    const hasMore = response.data.hasMore;
    return {data, hasMore};
}

ActCompletionWorkService.generateAcwForGroup = async function (id) {
    const response = await axios({
        method: "post",
        url: API_BASE_URL + `/api/admin/act-completion-work/generate/acw`,
        params: {
            groupId: id
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
    const data = response.data.list;
    const hasMore = response.data.hasMore;
    return {data, hasMore};
}

// format: 'pdf' | 'docx'
ActCompletionWorkService.getACWResource = async function (id, format = 'pdf') {
    return axios({
        method: "get",
        url: API_BASE_URL + `/api/admin/act-completion-work/get/acw/${id}/resource`,
        params: {format: format},
        responseType: "blob",
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

ActCompletionWorkService.getASPResource = async function (id, format = 'pdf') {
    return axios({
        method: "get",
        url: API_BASE_URL + `/api/admin/act-completion-work/get/asp/${id}/resource`,
        params: {format: format},
        responseType: "blob",
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}
export default ActCompletionWorkService;